import { useTranslation } from 'react-i18next'
import { LinkButton } from '../button/link-button'
import Text from '../text/text'

export default function UserBanner() {
	const { t } = useTranslation()
	return (
		<div className="animate-pulse-slow relative overflow-hidden rounded-lg border border-secondary/20 bg-linear-to-r from-secondary/10 to-secondary/5 p-8 shadow-[0_0_15px_rgba(var(--color-secondary-rgb),0.15)] before:absolute before:inset-0 before:-z-10 before:rounded-lg before:border before:border-secondary/30 before:blur-[2px]">
			<div className="flex flex-row justify-between">
				<div className="relative z-10 w-full md:w-1/2 2xl:max-w-4xl">
					<Text as="h2" className="mb-4">
						{t('misc_user_banner_title')}
					</Text>
					<Text className="mb-8">{t('misc_user_banner_description')}</Text>
					<div className="flex flex-col gap-2 sm:flex-row md:flex-row">
						<LinkButton variant="outline-light" to="/signup">
							<span className="px-4">{t('action_create_account')}</span>
						</LinkButton>
					</div>
				</div>

				<div className="hidden items-center gap-2 md:flex lg:gap-4 xl:gap-4">
					<div className="h-32 w-32 overflow-hidden rounded-lg lg:h-40 lg:w-40 xl:h-48 xl:w-48">
						<img
							src="/img/concert2.webp"
							alt=""
							className="h-full w-full object-cover"
						/>
					</div>
					<div className="h-24 w-24 overflow-hidden rounded-lg lg:h-28 lg:w-28 xl:h-32 xl:w-32">
						<img
							src="/img/beverage-tasting.webp"
							alt=""
							className="h-full w-full object-cover"
						/>
					</div>
					<div className="h-32 w-32 overflow-hidden rounded-lg lg:h-40 lg:w-40 xl:h-48 xl:w-48">
						<img
							src="/img/concert.webp"
							alt=""
							className="h-full w-full object-cover"
						/>
					</div>
				</div>
			</div>
		</div>
	)
}
